import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef,
  OnDestroy,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { PropertyService } from "../shared/property.service";
import { OwlOptions } from "ngx-owl-carousel-o";
import { DataShareService } from "../shared/data-share.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Title } from "@angular/platform-browser";
import _ from "lodash";
import { EncrDecrService } from "../shared/EncrDecrService.service";
import { ToastrService } from "ngx-toastr";
import { environment } from "../../../environments/environment";
import { Loader, LoaderOptions } from "google-maps";
import { Lightbox as box } from "ngx-lightbox";
import { forEach } from "@angular/router/src/utils/collection";
import { Subscription } from "rxjs";
import { debounce } from "lodash";
@Component({
  selector: "app-properties-list",
  templateUrl: "./properties-list.component.html",
  styleUrls: ["./properties-list.component.css"],
})
export class PropertiesListComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  // infinite scroll settings
  public _get = _.get;
  public _uniqBy = _.uniqBy;
  public propertiesList = [];
  public properties = [];
  public currentPage = 1;
  public throttle = 300;
  public scrollDistance = 4;
  public scrollUpDistance = 2;
  public search_obj = {};
  public hasNoPropertyRecords = false;
  public hasNoSearchPropertyRecords = false;
  public isDisplayMap = false;
  public user = null;
  // public imageUrl = environment.imageUrl + "property_image/";
  public imageUrl = environment.imageUrl + "uploads/thumb/";

  public lat: number = -33.8781954;
  public long: number = 151.2031137;
  // carousel settings
  public customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    autoplay: false,
    autoWidth: true,
    navSpeed: 700,
    navText: ["&#8249;", "&#8250;"],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 2,
      },
      740: {
        items: 3,
      },
      940: {
        items: 4,
      },
    },
    nav: true,
  };
  @ViewChild("mapView") mapElement: ElementRef;
  public options: LoaderOptions = {
    /* todo */
  };
  public loader = new Loader(
    "AIzaSyB_L4pPNYwWjRXJM_lFvRfKWCNK2L3oNDs",
    this.options
  );

  private subscriptions: Subscription = new Subscription();
  mapView: google.maps.Map | null = null;
  mapMarkers: google.maps.Marker[] = [];
  mapBounds: google.maps.LatLngBounds | null = null;
  previousZoom: number;
  fetchMapData: () => void;
  private userInteracted: boolean = false;
  infoWindow: google.maps.InfoWindow | null = null;

  constructor(
    private route: ActivatedRoute,
    private propertyService: PropertyService,
    private dataShare: DataShareService,
    private spinner: NgxSpinnerService,
    private titleService: Title,
    private EncrDecr: EncrDecrService,
    private toastr: ToastrService,
    private lightbox: box,
    private router: Router
  ) {
    this.titleService.setTitle(this.route.snapshot.data["title"]);
    window.scrollTo(0, 0);
    this.spinner.show("outer");
    this.propertiesList = [];
    this.properties = this.route.snapshot.data["propertyList"];
    this.search_obj = JSON.parse(localStorage.getItem("search_obj"));
    this.fetchMapData = debounce(this.fetchMapDataImpl.bind(this), 800);
  }

  createPropertyAraay(properties) {
    console.info("--------------------------");
    console.info("CREATE_PROPERTY =>", properties);
    console.info("--------------------------");
    let list = [];
    // properties.forEach((p) => {
    //   if (p.hasOwnProperty("listing")) {
    //     list.push(p.listing);
    //   }
    //   if (p.hasOwnProperty("listings")) {
    //     if (p.listings.length > 0) {
    //       p.listings.forEach((ele) => {
    //         list.push(ele);
    //       });
    //     }
    //   }
    // });
    if (properties && properties.data) {
      for (let index = 0; index < properties.data.length; index++) {
        const propertyItem = properties.data[index];
        // let propertyImg = []
        // propertyItem.image.forEach(item => {
        //   propertyImg.push({...item, path: `${this.imageUrl}${item.path}`})
        // })
        // propertyItem.image = propertyImg
        // console.info('--------------------------')
        // console.info('propertyItem =>',propertyItem)
        // console.info('--------------------------')
        list.push(propertyItem);
      }
    }
    if (list.length === 0) {
      this.hasNoPropertyRecords = true;
    } else {
      this.hasNoPropertyRecords = false;
    }
    this.addItems(list);
    this.spinner.hide("outer");
  }

  addItems(list) {
    const cnt = list.length;
    for (let i = 0; i < cnt; i++) {
      this.propertiesList["push"](list[i]);
    }
    this.propertiesList = this._uniqBy(this.propertiesList, (obj) =>
      [this._get(obj, "_id", "")].join()
    );
    this.spinner.hide("outer");
  }

  onScrollDown() {
    this.currentPage += 1;
    this.search_obj["page"] = this.currentPage;
    // this.dataShare.changeSearchObj(this.search_obj);
    this.search_obj["limit"] = 10;
    this.propertyService
      .getProperties(this.search_obj)
      .toPromise()
      .then(async (res) => {
        this.hasNoPropertyRecords = false;
        await this.createPropertyAraay(res);
        if(res['data']['length'] && this.isDisplayMap) {
          this.getInitRoadMap();
        }
      });
  }

  followProperty(propertyId, propertyDetails) {
    let userId = this.user.data._id;
    let search_obj = JSON.parse(localStorage.getItem("search_obj"));
    let findFollow = this.isFollowing(propertyDetails.favDetail)
      ? this.isFollowing(propertyDetails.favDetail)
      : null;
    let status = 1;
    console.info("--------------------------");
    console.info("findFollow =>", findFollow);
    console.info("--------------------------");
    if (findFollow) {
      if (findFollow.fav_status === 1) {
        status = 2;
      } else {
        status = 1;
      }
    } else {
      status = 1;
    }

    this.propertyService
      .addToFavouritesProperty(userId, status, propertyId)
      .toPromise()
      .then(async (res: any) => {
        console.info("--------------------------");
        console.info("FOLLOW_PROPERTY_STATUS =>", res);
        console.info("--------------------------");
        if (res.code == 200) {
          if (status === 1) {
            this.toastr.success(
              "Successfully marked property as favourites",
              "Success!",
              {
                timeOut: 3000,
              }
            );
          } else if (status === 2) {
            this.toastr.success(
              "Successfully unmarked property as favourites",
              "Success!",
              {
                timeOut: 3000,
              }
            );
          }
        }
        this.spinner.show("outer");
        this.dataShare.changeSearchObj(search_obj);
        localStorage.setItem("search_obj", JSON.stringify(search_obj));
      });
  }

  isFollowing(favDetails = []) {
    if (this.user) {
      let findFav = _.filter(
        favDetails,
        (fav) => fav.fav_by === this.user.data._id
      );
      if (findFav.length > 0) {
        return findFav[0];
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  ngOnInit() {
    this.subscriptions.add(
      this.dataShare.isDisplayMap.subscribe((data) => {
        this.isDisplayMap = data;
        console.log("isDisplayMap =>", this.isDisplayMap);
        if (this.isDisplayMap) {
          this.getInitRoadMap();
        } else if (this.mapView) {
          // Clear the map markers and bounds when switching to list view
          this.mapMarkers.forEach((marker) => marker.setMap(null));
          this.mapMarkers = [];
          this.mapBounds = null;
          this.mapView = null;
        }
      })
    );

    this.subscriptions.add(
      this.dataShare.currentsearchObj.subscribe(async (s_obj) => {
        this.spinner.show("outer");

        if (!s_obj) {
          this.hasNoPropertyRecords = false;
          await this.createPropertyAraay(this.properties);
          this.spinner.hide("outer");
          return;
        }

        this.propertiesList = [];
        this.search_obj = { ...s_obj, page: 1, limit: 10 };
        this.currentPage = 1;
        if (this.isDisplayMap) {
          if (this.mapView) {
            this.mapMarkers.forEach((marker) => marker.setMap(null));
            this.mapBounds = null;
            this.mapView = null;
          }
          this.getInitRoadMap();
        }
        try {
          let res: any = await this.propertyService.getProperties(this.search_obj).toPromise();

          if (res.code === 400) {
            this.search_obj = { ...this.search_obj, locations: [], page: 1, limit: 10 };
            res = await this.propertyService.getProperties(this.search_obj).toPromise();
            this.hasNoSearchPropertyRecords = true;
          } else {
            this.hasNoSearchPropertyRecords = false;
          }

          this.hasNoPropertyRecords = false;
          await this.createPropertyAraay(res);
        } catch (error) {
          console.error("API call failed:", error);
          this.hasNoPropertyRecords = true;
        }

        this.spinner.hide("outer");
      })
    );

    this.subscriptions.add(
      this.dataShare.loginUser.subscribe((data) => {
        if (data) {
          this.user = localStorage.getItem("user")
            ? this.EncrDecr.getEncrypt(localStorage.getItem("user"))
            : null;
          console.log("this.user :: 1 => ", this.user);
        } else {
          this.user = localStorage.getItem("user")
            ? this.EncrDecr.getEncrypt(localStorage.getItem("user"))
            : null;
          console.log("this.user :: 1 => ", this.user);
        }
      })
    );
  }

  ngAfterViewInit() {}

  private fetchMapDataImpl(): void {
    if (!this.userInteracted || !this.mapView) return;
    const bounds = this.mapView.getBounds();
    const zoom = this.mapView.getZoom();
    if (!bounds || !zoom) return;
    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();
    const payload = {
      zoom: zoom,
      bounds: {
        northEast: { lat: ne.lat(), lng: ne.lng() },
        southWest: { lat: sw.lat(), lng: sw.lng() },
      },
    };
    this.propertyService.getMapDomainList(payload).subscribe({
      next: (res: any) => {
        if (!res.data.length) return;

        const newMarkers: google.maps.Marker[] = [];

        res.data.forEach((item: any) => {
          const position = new google.maps.LatLng(+item.latitude, +item.longitude);
          const isDuplicate = this.mapMarkers.some(
            (m) => m.getPosition().equals(position)
          );
          if (isDuplicate) return;
          const marker = new google.maps.Marker({
            position,
            map: this.mapView,
            title: item.address || "No address",
            clickable: true,
            visible: true,
          });
          marker.addListener("click", () => {
            if (this.infoWindow) this.infoWindow.close();
            this.propertyService.getPropertyDetails(item._id).subscribe((res: any) => {
              if (res.code === 200) {
                const property = res.data;
                const imagePath = property.image && property.image.length > 0 && property.image[0].path ? property.image[0].path : 'https://staging.ownly.com.au/assets/images/default_property.png';
                const imageUrl = (imagePath.startsWith('http://') || imagePath.startsWith('https://')) ? imagePath : `${this.imageUrl}${imagePath}`;
                const content = `
                  <div style="max-width: 220px; font-family: Arial; font-size: 14px;">
                    <img src="${imageUrl}" alt="Property Image" style="width: 100%; height: auto; border-radius: 4px; margin-bottom: 8px;" />
                    <strong>${property.property_type || "Property"}</strong><br>
                    ${property.address || "No address"}<br>
                    ${property.price ? "$" + property.price : ""}<br>
                    <a href="/property/${property._id}" target="_blank">View Details</a>
                  </div>
                `;
                this.infoWindow = new google.maps.InfoWindow({ content });
                this.infoWindow.open(this.mapView, marker);
              }
            });
          });
          this.mapMarkers.push(marker);
          newMarkers.push(marker);
        });
        if (newMarkers.length > 0) {
          newMarkers.forEach((m) => this.mapBounds.extend(m.getPosition()!));
        }
      },
      error: (err) => {
        console.error("Error fetching map domain list:", err);
      },
    });
  }

  getInitRoadMap() {
    const fenway = { lat: -37.840935, lng: 144.946457 };
    console.log("map id===>", document.getElementById("mapView"));
    setTimeout(() => {
      const mapContainer = document.getElementById("mapView");
      if (!mapContainer) return;
      if (!this.mapView) {
        this.mapView = new google.maps.Map(mapContainer, {
          center: fenway,
          zoom: 17,
          clickableIcons: true,
          streetViewControl: true,
          streetViewControlOptions: {
            position: google.maps.ControlPosition.LEFT_CENTER,
          },
          zoomControl: true,
          zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_BOTTOM,
          },
          fullscreenControl: true,
          fullscreenControlOptions: {
            position: google.maps.ControlPosition.LEFT_TOP,
          },
          styles: [
            {
              featureType: "all",
              elementType: "all",
              stylers: [{ visibility: "on" }],
            },
          ],
        });
        this.mapBounds = new google.maps.LatLngBounds();
        this.mapMarkers = [];
        this.mapView.addListener("dragend", () => {
          this.userInteracted = true;
          this.fetchMapData();
        });
        this.mapView.addListener("zoom_changed", () => {
          this.userInteracted = true;
          this.fetchMapData();
        });
        this.propertiesList.forEach((element) => {
          const position = { lat: +element.latitude, lng: +element.longitude };
          const isDuplicate = this.mapMarkers.some(
            (m) =>
              m.getPosition().lat() === position.lat &&
              m.getPosition().lng() === position.lng
          );
          if (isDuplicate) return;
          const marker = new google.maps.Marker({
            position,
            map: this.mapView,
            title: element.address,
            place: element.city,
            clickable: true,
            visible: true,
          });
          marker.addListener("click", () => {
            if (this.infoWindow) this.infoWindow.close();
            this.propertyService.getPropertyDetails(element._id).subscribe((res: any) => {
              if (res.code === 200) {
                const property = res.data;
                const imagePath = property.image && property.image.length > 0 && property.image[0].path
                ? property.image[0].path : 'https://staging.ownly.com.au/assets/images/default_property.png';
                const imageUrl = (imagePath.startsWith('http://') || imagePath.startsWith('https://')) ? imagePath : `${this.imageUrl}${imagePath}`;
                console.log('property: ', property);
                const content = `
                  <div style="max-width: 220px; font-family: Arial; font-size: 14px;">
                    <img src="${imageUrl}" alt="Property Image" style="width: 100%; height: auto; border-radius: 4px; margin-bottom: 8px;" />
                    <strong>${property.property_type || "Property"}</strong><br>
                    ${property.address || "No address"}<br>
                    ${property.price ? "$" + property.price : ""}<br>
                    <a href="/property/${property._id}" target="_blank">View Details</a>
                  </div>
                `;
                this.infoWindow = new google.maps.InfoWindow({ content });
                this.infoWindow.open(this.mapView, marker);
              }
            });
          });
          this.mapMarkers.push(marker);
          this.mapBounds.extend(position);
        });
        if (this.mapMarkers.length > 0) {
          this.mapView.fitBounds(this.mapBounds);
        }
      }
    }, 1000);
  }
  
  openPropertyDetailPage(property: any): void {
    console.log(property);
    this.router.navigate([`/property/${property._id}`]);
  }

  openImagePopup(imagePath, index) {
    const processedImages = imagePath.map(img => {
    const fullPath = (img.path.startsWith('http') || img.path.startsWith('https')) 
      ? img.path 
      : this.imageUrl + img.path;

    return {
      src: fullPath,
      thumb: fullPath,
      caption: ''
    };
  });
    this.lightbox.open(processedImages, index, {
      wrapAround: true,
      showImageNumberLabel: false,
      disableScrolling: false,
      positionFromTop: 100,
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.search_obj = {};
    // this.propertiesList = [];
    // this.properties = [];
    // this.currentPage = 1;
    // this.hasNoPropertyRecords = false;
    // this.hasNoSearchPropertyRecords = false;
    // this.isDisplayMap = false;
    // this.user = null;
    // localStorage.removeItem("search_obj");
  }
}
